import { Injectable } from '@angular/core';

import { LocalAppLauncherService } from './local-app-launcher.service';

@Injectable()
export class OfficeHomeLocalAppLauncherService implements LocalAppLauncherService {

    public async launchOfficeApp(_appName: string, _filePath?: string, _preLaunchCallback?: () => void, _isExcelCreateNew?: boolean): Promise<boolean> {
        return Promise.reject();
    }

    public async launchOfficeAppWithTemplate(_appName: string, _templateUrl: string): Promise<boolean> {
        return Promise.reject();
    }

    public async openPathInExplorer(_path: string): Promise<void> {
        return Promise.reject();
    }

    public async shouldOpenInOfficeApp(_appName: string): Promise<boolean> {
        return Promise.resolve(false);
    }
}
